import { make } from "vuex-pathify";
import { CommentsService } from "../services/comments.service.js";
import Logger from "@/lib/logger.js";

const service = new CommentsService();

export const state = {
  selectedLoanComments: [],
  selectedLoan: {}
};

export const mutations = {
  ...make.mutations(state)
};

export const actions = {
  async createComment({ dispatch }, comment) {
    try {
      const { data } = await service.createComment(comment);
      dispatch('getComments');
      return data;
    } catch (error) {
      Logger.error('Error While Creating Comment');
      throw error;
    }
  },

  async getComments({ commit, state }) {
    try {
      const { data } = await service.getComments(state.selectedLoan.id);
      commit('SET_SELECTED_LOAN_COMMENTS', data);
      return data;
    } catch (error) {
      Logger.error('Error While Fetching Comment');
      throw error;
    }
  },

  async updateComment({ dispatch }, { id, updates }) {
    try {
      const { data } = await service.updateComment(id, updates);
      dispatch('getComments');
      return data;
    } catch (error) {
      Logger.error('Error While Updating Comment');
      throw error;
    }
  },

  async deleteComment({ dispatch }, { userId, commentId }) {
    try {
      const { data } = await service.deleteComment(userId, commentId);
      dispatch('getComments');
      return data;
    } catch (error) {
      Logger.error('Error While Deleting Comment');
      throw error;
    }
  }
};
